import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as s } from "react";
const i = ({
  title: e,
  titleId: c,
  ...o
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": c,
    ...o,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: c, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M928.853 438.827c2.7-3.536 4.325-8.017 4.325-12.878 0-9.831-6.649-18.108-15.696-20.581l-.15-.035-231.68-68.693c-5.008-1.458-9.148-4.559-11.898-8.669l-.049-.077-135.893-211.413c-3.859-5.908-10.44-9.758-17.92-9.758s-14.061 3.85-17.87 9.677l-.05.082-136.107 211.413c-2.749 4.152-6.809 7.244-11.582 8.707l-.151.04-232.32 68.693c-8.816 2.753-15.103 10.844-15.103 20.403a21.24 21.24 0 0 0 4.052 12.512l-.043-.062 149.333 206.293c2.537 3.467 4.059 7.815 4.059 12.518 0 .174-.002.348-.006.521v-.026l-8.107 253.227a20.34 20.34 0 0 0-.039 1.285c0 11.782 9.551 21.333 21.333 21.333 2.617 0 5.123-.471 7.44-1.333l-.147.048 227.413-82.987c2.158-.805 4.651-1.271 7.253-1.271s5.095.466 7.401 1.319l-.148-.048 226.987 82.347c2.169.814 4.675 1.285 7.292 1.285 11.782 0 21.333-9.551 21.333-21.333 0-.452-.014-.901-.042-1.346l.003.061-6.613-252.587a21.237 21.237 0 0 1 3.885-13.08l-.045.067zM715.52 595.413c-13.333 17.899-21.346 40.447-21.346 64.866 0 .596.005 1.19.014 1.784l-.001-.09 4.267 163.413-142.72-51.627c-11.101-4.192-23.934-6.62-37.333-6.62s-26.232 2.427-38.083 6.866l.749-.246-142.933 51.627 5.973-164.053c.008-.487.012-1.062.012-1.638 0-24.647-8.007-47.424-21.562-65.872l.217.31-98.987-136.96 149.333-44.8c25.538-7.772 46.55-23.941 60.329-45.228l.258-.425 85.333-131.413 85.333 131.413c14.14 21.697 35.211 37.855 60.023 45.449l.777.205 149.333 44.8z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t = s(i);
export {
  t as default
};
